// this file retruns a function that returns the environment name based on the NODE_ENV variable
// this is used to determine which environment to use for the app

export const getEnvironment = () => {
    switch (window.location.hostname) {
        case 'localhost':
            return 'development';
        case '127.0.0.1':
            return 'development';
        case 'stg.radlenk.com':
            return 'staging';
        default:
            return 'production';
    }
}

export const isDevelopment = () => {
    return getEnvironment() === 'development';
}

export const isStaging = () => {
    return getEnvironment() === 'staging';
}

export const isProduction = () => {
    return getEnvironment() === 'production';
}